export let bannerBackgroundImageContainer;

function findClosestSourceSets(sourceSets) {
    let escapeOnNextIteration = false;
    let srcSet = [];
    sourceSets.each(function () {
        if ($(this).data('width') >= window.outerWidth) {
            if (escapeOnNextIteration) {
                srcSet['nextWidth'] = $(this).data('width');
                return false;
            } else {
                srcSet['src'] = $(this).data('src');
                srcSet['width'] = $(this).data('width');
                escapeOnNextIteration = true;
            }
        }
        if (!escapeOnNextIteration) {
            srcSet['prevWidth'] = $(this).data('width');
        }
    });
    return srcSet;
}

export function initBannerBackgroundImageContainer() {
    $('.c3base-bannerBackgroundImage').each(function () {
        if (
            !$(this).find('.c3base-bannerBackgroundImage-image-container').attr('data-current-source-set') ||
            window.outerWidth <=
                $(this).find('.c3base-bannerBackgroundImage-image-container').attr('data-prev-source-set') ||
            window.outerWidth >=
                $(this).find('.c3base-bannerBackgroundImage-image-container').attr('data-current-source-set')
        ) {
            let sourceSets = $(this).find('.image-data-container div');
            let resultSourceSet = findClosestSourceSets(sourceSets);
            $(this)
                .find('.c3base-bannerBackgroundImage-image-container')
                .css({
                    backgroundImage: 'url(' + resultSourceSet['src'] + ')',
                })
                .attr('data-current-source-set', resultSourceSet['width'])
                .attr('data-next-source-set', resultSourceSet['nextWidth'])
                .attr('data-prev-source-set', resultSourceSet['prevWidth']);
        }
        bannerBackgroundImageContainer = true;
    });
}
